export const ENVIRONMENTAL_LABELS_0_ID = '0'
export const ENVIRONMENTAL_LABELS_ECO_ID = 'ECO'
export const ENVIRONMENTAL_LABELS_B_ID = 'B'
export const ENVIRONMENTAL_LABELS_C_ID = 'C'

export const ENVIRONMENTAL_LABELS_IDS = {
  ZERO: '0',
  ECO: 'ECO',
  B: 'B',
  C: 'C'
}

export const ENVIRONMENTAL_LABELS = {
  [ENVIRONMENTAL_LABELS_IDS.ZERO]: {
    icon: 'images/common/eco-label-icons/0.svg',
    id: ENVIRONMENTAL_LABELS_IDS.ZERO,
    name: 'COMMON.ENVIRONMENTAL_LABELS.0'
  },
  [ENVIRONMENTAL_LABELS_IDS.ECO]: {
    icon: 'images/common/eco-label-icons/eco.svg',
    id: String(ENVIRONMENTAL_LABELS_IDS.ECO),
    name: 'COMMON.ENVIRONMENTAL_LABELS.ECO'
  },
  [ENVIRONMENTAL_LABELS_IDS.B]: {
    icon: 'images/common/eco-label-icons/b.svg',
    id: String(ENVIRONMENTAL_LABELS_IDS.B),
    name: 'COMMON.ENVIRONMENTAL_LABELS.B'
  },
  [ENVIRONMENTAL_LABELS_IDS.C]: {
    icon: 'images/common/eco-label-icons/c.svg',
    id: String(ENVIRONMENTAL_LABELS_IDS.C),
    name: 'COMMON.ENVIRONMENTAL_LABELS.C'
  }
}
